import React from 'react';
import ReactDatepicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import {FieldProp} from '../../types';

type DateProps = FieldProp & {};

const formatDate = (date: Date): string => {
    let month = '' + (date.getMonth() + 1);
    let day = '' + date.getDate();
    const year = date.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
};

const dateFromString = (dateString: string): Date | null => {
    if (dateString && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const parts: string[] = dateString.split('-');
        // @ts-ignore
        return new Date(parts[0], parts[1] - 1, parts[2]);
    }
    return null;
};

const formatDateForDisplay = (date: string, format: string): string => {
    if (date && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const parts: string[] = date.split('-');
console.log('format is ', format);
        if (format === 'MMMM-dd-yyyy') {
            const monthNames = {
                '01': 'January',
                '02': 'February',
                '03': 'March',
                '04': 'April',
                '05': 'May',
                '06': 'June',
                '07': 'July',
                '08': 'August',
                '09': 'September',
                '10': 'October',
                '11': 'November',
                '12': 'December'
            };
            // @ts-ignore
            return [monthNames[parts[1]], parts[2], parts[0]].join('-');
        } else if (format === 'd MMM yyyy') {
            const monthNames = {
                '01': 'Jan',
                '02': 'Feb',
                '03': 'Mar',
                '04': 'Apr',
                '05': 'May',
                '06': 'Jun',
                '07': 'Jul',
                '08': 'Aug',
                '09': 'Sep',
                '10': 'Oct',
                '11': 'Nov',
                '12': 'Dec'
            };
            // @ts-ignore
            return [parts[2], monthNames[parts[1]], parts[0]].join(' ');
        } else {
            return [parts[1], parts[2], parts[0]].join('/');
        }
    }
    return date;
};

export const Datepicker: React.FunctionComponent<DateProps> = ({
                                                                   field,
                                                                   fieldState,
                                                                   value,
                                                                   displayOnly,
                                                                   onChange,
                                                                   onBlur,
                                                               }): JSX.Element => {
    const {
        touched,
        pristine,
        validating,
        valid,
        invalid,
        errors,
    } = fieldState;

    const classNames = [
        'form-control',
        touched && 'is-touched',
        pristine && 'is-pristine',
        validating && 'is-validating',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    const minDateToday = field?.flowCustomDisplayComponentConfig?.minDateToday || false;
    let customComponentProps = {};
    if (minDateToday) {
        customComponentProps.minDate = new Date();
    }

    return (
        <div>
            {displayOnly ? formatDateForDisplay(value, field?.dateDisplayFormat) :
                <ReactDatepicker
                    id={field.htmlId}
                    required={field.isRequired}
                    className={classNames}
                    dateFormat={field?.dateDisplayFormat || 'MM/dd/yyyy'}
                    onChange={(dateObj: Date) => {
                        onChange && onChange(formatDate(dateObj));
                    }}
                    onBlur={() => {
                        onBlur && onBlur()
                    }}
                    selected={dateFromString(value)}
                    {...customComponentProps}
                />
            }
            {errors && errors.map((error: string, index: number) => (
                <div key={index} className="invalid-feedback">
                    {error}
                </div>
            ))}
        </div>
    );
};
